import {
  Row,
  Col,
  Button,
  Modal,
  Radio,
  Spin,
  Form,
  Space,
  Input,
  Card,
  message,
  Tag,
} from "antd";
import { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { lazy } from "react";
import { Suspense } from "react";
import EMILayout from "./components/EMILayout";

const MoreContent = ({ prefixTitle = "", title = "首頁" }) =>
  // permissionId = 33,
  {
    const [moreContentData, setMoreContentData] = useState("");
    const [blogViewCount, setBlogViewCount] = useState(0);
    const { blogId } = useParams();

    useEffect(() => {
      // if (blogId > 0) {
      axios
        .get("/dynamicWebsite/frontend/blog", {
          params: {
            blog_id: blogId,
          },
        })
        .then((response) => {
          if (response?.data?.data && response?.data?.data.length !== 0) {
            // console.log(response?.data?.data?.[0]?.more_content);
            document.title = `${prefixTitle} | ${response?.data?.data?.[0]?.title}`

            setMoreContentData(response?.data?.data?.[0]?.more_content);
            setBlogViewCount(response?.data?.data?.[0]?.view_count);
            patchBlogClick();
          }
        });
      // }
    }, [blogId]);

    const patchBlogClick = () => {
      axios
        .patch("/dynamicWebsite/frontend/blog/click", [
          {
            blog_id: blogId,
          },
        ])
        .then((response) => {});
    };

    return (
      <Row
        gutter={[10, 20]}
        justify="space-around"
        style={{ padding: "3vmin" }}
      >
        <Col span={24} style={{ textAlign: "right" }}>
          文章點擊人次：{blogViewCount}
        </Col>
        <Col span={24}>
          <Row gutter={[10, 20]} justify="space-around">
            <Col span={20}>
              <div dangerouslySetInnerHTML={{ __html: moreContentData }} />
            </Col>
          </Row>
        </Col>
      </Row>
    );
  };
export default MoreContent;
